module.exports = __webpack_public_path__ + "images/sns_campaign_lp/sns_campaign_ogp_53908f24e14cbeac07677b497e474d07.jpg";